import type { WhitelabelVariantDefinition } from '../../types';

export const youviaWhitelabel = {
  id: 'youvia',
  colors: {
    primary: {
      900: '#000000',
      800: '#1C1C1C',
      700: '#252525',
      500: '#515151',
      300: '#A8A8A8',
      100: '#E9E9E9',
      contrastText: '#E0E0E0',
    },
  },
} as const;

export const youviaDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: youviaWhitelabel.colors.primary[900],
      dark: youviaWhitelabel.colors.primary[800],
      main: youviaWhitelabel.colors.primary[700],
      light: youviaWhitelabel.colors.primary[500],
      lighter: youviaWhitelabel.colors.primary[300],
      muted: youviaWhitelabel.colors.primary[100],
      contrastText: youviaWhitelabel.colors.primary.contrastText,
    },
  },
};
